import React from 'react';
import { Link } from "react-router-dom";
import '../css/home.css';

export default function Home() {
    return (
        <div className='homePage'>
            <div className='gridContainer'>
                <div className='gridItem box1'>
                    <h1 className='headerAbout'>Motyvacija investuoti šiuolaikiškai!</h1>
                    <p className='mainPAbout'>Asmeninis finansų patarėjas yra tavo asmeninis treneris, padedantis pasiekti finansinę laisvę ir gerovę.
                        Jis padės tau sukurti aiškų planą, nustatyti tikslus ir išmokyti naudotis įrankiais, kurie padės tau pasiekti tuos tikslus.
                        Neieškok pasiteisinimų pradėk šiandien! Pirmoji edukacinė konsultacija nemokamai!
                    </p>
                    <Link to="/konsultacija" className="mainButton">Registruokis konsultacijai!</Link><br />
                    <p className="mainTextUnder">*Pirma konsutacija nemokama!</p>
                </div>
                <div className='gridItem box2'></div>
                <div className='gridItem box3'></div>
                <div className='gridItem box4'>
                    <h1 className='headerAbout'>Tavo nauja karjeros galimybė<br />Sužinok daugiau - užsiregistruok dabar!</h1>
                    <h2>LAISVĖ</h2>
                    <p className='mainPAbout'>Gali dirbti online iš kur nori, kiek nori ir kada nori - bet tam, kad turėtum apčiuopiamus rezultatus, reikės skirti bent 20 valandų per savaitę.
                    </p>
                    <h2><br />AUGIMAS</h2>
                    <p className='mainPAbout'>Mokymų sistema prieinama online 24 valandas per parą. <br />
                        Aiškus planas naujokui bei pažengusiems tam, kad nuolat tobulėtum ir realizuotum savo potencialą.
                    </p>
                    <h2><br />MOTYVACIJA</h2>
                    <p className='mainPAbout'>Skiriant 20 valandų per savaitę, per pirmus veiklos metus uždirbsi nuo 0 iki 2000 Eurų per mėnesį. <br />
                        Galimybė kilti karjeros laiptais ir tapti vadovu.
                    </p>
                    <Link to="/karjera" className="mainButton">Registruokis karjerai</Link><br />
                </div>
                <div className='gridItem box5'>
                    <h1 className='headerAbout'>Kreipkitės!</h1>
                    <p className='mainPAbout'>Turite klausimų, norite pasikonsultuoti, domitės asmeninių finansų valdymu ar mūsų veikla? Bendraukime!
                    </p>
                    <Link to="/apie" className="mainButton">Susisiekite</Link><br />
                </div>
                <div className='gridItem box6'></div>
            </div>
        </div>
    )
}